<div class="row">
    <div class="col-12" *ngIf="showDestinationCriteria">
        <bds-destination-criteria
            [customerNumber]="customerNumber"
            [locationCity]="destinationCity"
            [locationState]="destinationState"
            [latestClm]="latestClm"
            (criteriaChanged)="onCriteriaChanged()"
        >
        </bds-destination-criteria>
    </div>
    <div class="col-12" *ngIf="showOriginCriteria">
        <bds-origin-criteria
            [locationCity]="originCity"
            [locationState]="originState"
            [latestClm]="latestClm"
            [returnCity]="returnCity"
            [returnState]="returnState"
            (criteriaChanged)="onCriteriaChanged()"
        >
        </bds-origin-criteria>
    </div>
</div>
